import React from 'react';
import { Grid } from '@material-ui/core';
import { Colors, PrimaryButton, Text } from 'library';
import { track } from 'shared';

export default function ComingSoon({
    setSection,
    large = false,
}: {
    setSection: (x: number) => void;
    large?: boolean;
}) {
    function handleNotifyMe() {
        track('User Profile Popup: Notify Me Button Clicked');
        setSection(2);
    }
    return (
        <Grid container direction="column">
            <Grid item>
                <Text variant="body2" color={Colors.turquoise}>
                    HANG TIGHT!
                </Text>
            </Grid>
            <Grid item>
                <Text variant={large ? 'display' : 'body1'}>Soon you'll be able to message another user!</Text>
            </Grid>
            <Grid item style={{ width: 150, paddingTop: 20 }}>
                <PrimaryButton onClick={handleNotifyMe}>Notify me</PrimaryButton>
            </Grid>
        </Grid>
    );
}
